/**
 * The Show / Hide Columns glyph, drawn as the reference draws it (`hideColumnIcon.png`): a rounded square split
 * down the middle into two columns.
 *
 * PrimeIcons has no such glyph, so it is an inline SVG -- sized in `em` and stroked in `currentColor`, so the
 * toolbar's existing `.ms__tool .pi` rules (19px, muted ink) size and colour it exactly as they did the icon
 * it replaces. It carries the `pi` class for that reason only.
 */
export function MasterColumnsIcon() {
  return (
    <svg
      className="pi ms__tool-svg"
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <rect x="3" y="3" width="14" height="14" rx="2.5" />
      <line x1="10" y1="3.5" x2="10" y2="16.5" />
    </svg>
  );
}
